module.exports = __webpack_public_path__ + "img/wenhua (5).cfc17f8e.png";